import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { useNavigate } from 'react-router';
import logoMainPage from '~/assets/logo.png';
import { MANAGER_LAYOUT_PATHS } from '../constants.ts';
import { managerLayoutStyles } from '../styles.ts';

const AppTitle: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ButtonBase
      onClick={() => navigate(MANAGER_LAYOUT_PATHS.home)}
      sx={managerLayoutStyles.appTitleButton}
    >
      <Box
        component="img"
        src={logoMainPage}
        alt="UKR EXIM BANK"
        sx={managerLayoutStyles.appTitleLogo}
      />
    </ButtonBase>
  );
};

export default AppTitle;
